import { doApi } from 'services/api'

const downloadDocument = (url, filename) => {
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const getEiarReportExists = async (reportYear, publicId) => {
  return await doApi({
    route: `nonautheiarexists/${encodeURIComponent(reportYear)}?publicId=${encodeURIComponent(publicId)}`,
    noAuth: true
  })
}

export const downloadEiarReport = async (reportYear, publicId) => {
  const response = await doApi({
    route: `nonauthgenerateeiarreport/${encodeURIComponent(reportYear)}?publicId=${encodeURIComponent(publicId)}`,
    noAuth: true
  })

  if (!response || !response.presignedUrl)
    return { error: 'Unable to access document' }

  downloadDocument(response.presignedUrl, response.prettyFilename)

  return response
}

export const downloadBrochure = async (reportType, reportYear, crmId) => {
  if (!crmId)
    return { error: 'Unable to access brochure' }

  const response = await doApi({
    route: `nonauthbrochureurl/${encodeURIComponent(reportType)}/${encodeURIComponent(reportYear)}?crmId=${encodeURIComponent(crmId)}`,
    noAuth: true
  })

  if (!response || !response.presignedUrl)
    return { error: 'Unable to access brochure' }

  downloadDocument(response.presignedUrl, response.fileName)
  return response
}
